// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1QENE","info":"PatientInfo_info__2oyXR"};